
<script>
import { layoutMethods, eloadMaintenanceMethods, eloadMaintenanceComputed, exportMethods, liteEloadDropdownMethods, liteEloadDropdownComputed } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
// import { getModuleAccess } from "@/router/helper.js";
import moment from "moment";

export default {
  page: {
    title: "ELoad Maintenance Dashboard",
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      orderBy: "id",
      sort: "DESC",
      sortBy: "created_at",
      sortDesc: true,
      submitted: false,
      networkOptions:[],
      search: {
        keyword: "",
        field: "",
        network: null,
        status: "",
        dateRange: null,
      },
      rangeOptions: {
        mode: "range",
      },
      searchFieldOptions: [
        { text: "All", value: "" },
        { text: "Added By", value: "created_by" },
      ],
      fields: [
        { key: "action", sortable: false },
        { key: "network", sortable: false },
        { key: "start_date", label: "Maintenance Start Date", sortable: true },
        { key: "end_date", label: "Maintenance End Date", sortable: true },
        { key: "status", sortable: true },
        { key: "created_by", label: "Added By", sortable: true },
      ],
      userAccess: {
        access: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      },
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...eloadMaintenanceComputed,
    ...liteEloadDropdownComputed,
    statusOptions() {
      return [
        { text: 'All', value: '' },
        { text: 'Scheduled', value: 'Scheduled' },
        { text: 'Ongoing', value: 'Ongoing' },
        { text: 'Ended', value: 'Ended' },
        { text: 'Cancelled', value: 'Cancelled' },
        { text: 'Force Cancelled', value: 'Force Cancelled' },
      ];
    },
  },
  methods: {
    ...layoutMethods,
    ...exportMethods,
    ...eloadMaintenanceMethods,
    ...liteEloadDropdownMethods,
    async sortOptions(propName, arr) {
      arr.sort((a, b) => {
        const nameA = a[`${propName}`].toUpperCase();
        const nameB = b[`${propName}`].toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return arr;
    },
    async getSKUNetworkList() {
      try {
        await this.fetchLiteNetworksList();
        
        if (this.getLiteNetworksList && this.getLiteNetworksList.length > 0) {
          let sortedList = await this.sortOptions('name', [...this.getLiteNetworksList]);
          this.networkOptions = [
            { id: null, text: "Select Filter", value: null },
            ...sortedList.map(network => ({
              id: network.id,
              text: network.name,
              value: network.id,
            })),
          ];

        }
      } catch (error) {
        console.error('Error loading network list:', error);
        this.$alertify.error('Failed to load network list');
      }
    },
    
    // lookup network name from lite networks first, then fallback to maintenance options
    getNetworkName(id) {
      if (id == null || id === "") return "--";
      const nid = Number(id);
      // check lite networks (preferred)
      const liteList = this.getLiteNetworksList || [];
      const foundLite = liteList.find(n => Number(n.id) === nid);
      if (foundLite) return foundLite.name;
      // fallback to maintenance networks
      const found = (this.eloadMaintenanceNetwork || []).find((n) => Number(n.id) === nid || Number(n.value) === nid || n == id);
      // console.log("foundLite:", foundLite, "found:", found, "id:", id);
      return found ? (found.name || found.text || id) : id;
    },
    async getMaintenanceList() {
      let params = {
        page: this.isSearching ? 1 : this.currentPage,
        rows: this.perPage,
        sort: this.sort,
        orderBy: this.orderBy,
        search: this.search,
      };

      await this.getEloadMaintenanceList(params).then(() => {
        this.isSearching = false;
      });
    },
    
    async onRefresh() {
      // Reset search/filter fields to defaults and reload list
      this.search.keyword = "";
      this.search.field = "";
      this.search.network = null;
      this.search.status = "";
      this.search.dateRange = null;
      this.currentPage = 1;
      this.isSearching = false;
      await this.getMaintenanceList();
    },
    async cancelSchedule(scheduleStatus,scheduleId) {
      let messageTitle = '', messageText = ''
      if(scheduleStatus=='cancelled') {
        messageTitle = 'Cancel Maintenance'
        messageText = 'Are you sure you want to cancel this scheduled maintenance? This action will stop the maintenance before it begins.'
      }
      if(scheduleStatus=='force-cancelled'){
        messageTitle = 'Force Cancel Maintenance'
        messageText = 'Are you sure you want to force cancel this maintenance? Any ongoing processes will be stopped immediately.'
      }  
      const { value: reason, isConfirmed } = await Swal.fire({
        title: messageTitle,
        html: `
          <div style="margin-bottom:14px;font-size: 18px;line-height:1.5;">${messageText}</div>
          <div style="margin-bottom:12px;font-size: 18px;">Please provide a reason for the ${scheduleStatus == 'force-cancelled' ? 'force cancellation' : 'cancellation'}:</div>
          <div style="text-align:left;position:relative;">
            <label style="display:block;margin-bottom:6px;font-size: 16px;font-weight: 500;">Reason<span style="color:#C12927">*</span></label>
            <input id="swal-reason-input" maxlength="50" class="swal2-input" placeholder="Enter reason..." style="width:100%;font-size: 14px;padding:10px 12px;border-radius:4px;height:auto;min-height:38px;border:1px solid #d1d5db;box-shadow:none;color:#333;box-sizing:border-box;text-indent:0;">
            <div id="swal-error-message" style="color:#C12927;font-size:13px;margin-top:4px;display:none;">Reason is required.</div>
            <div style="text-align:right;margin-top:3px;"><small id="swal-reason-counter" style="font-size:12px;color:#9ca3af">0/50</small></div>
          </div>
        `,
        icon: "warning",
        width: 560,
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          content: 'swal-custom-content',
          confirmButton: 'swal-custom-confirm',
          cancelButton: 'swal-custom-cancel',
          icon: 'swal-custom-icon'
        },
        showCancelButton: true,
        confirmButtonColor: "#6f42c1",
        cancelButtonColor: "#C12927",
        confirmButtonText: "Confirm",
        cancelButtonText: "No",
        focusConfirm: false,
        didOpen: () => {
          const input = document.getElementById("swal-reason-input");
          const counter = document.getElementById("swal-reason-counter");
          const errorMsg = document.getElementById("swal-error-message");
          
          if (input && counter) {
            counter.innerText = `${input.value.length}/50`;
            input.addEventListener("input", () => {
              counter.innerText = `${input.value.length}/50`;
              // Hide error message when user starts typing
              if (errorMsg && input.value.trim().length > 0) {
                errorMsg.style.display = 'none';
                input.style.borderColor = '#d1d5db';
              }
            });
            input.focus();
          }
        },
        preConfirm: () => {
          const el = document.getElementById("swal-reason-input");
          const errorMsg = document.getElementById("swal-error-message");
          const val = el ? el.value : "";
          
          if (!val || val.trim().length === 0) {
            if (errorMsg) {
              errorMsg.style.display = 'block';
            }
            if (el) {
              el.style.borderColor = '#C12927';
            }
            return false;
          }
          if (val.length > 50) {
            if (errorMsg) {
              errorMsg.textContent = 'Reason must be 50 characters or less.';
              errorMsg.style.display = 'block';
            }
            if (el) {
              el.style.borderColor = '#C12927';
            }
            return false;
          }
          return val.trim();
        },
      });

      if (!isConfirmed) return;

      try {
        let payload = {
          id: scheduleId,
          status: scheduleStatus == 'force-cancelled' ? 'Force Cancelled' : 'Cancelled',
          reason: reason,
        };

        let response = await this.cancelEloadMaintenance(payload);
        if (response && response.status == "ok") {
          const okText = scheduleStatus == "force-cancelled" ? "The maintenance has been successfully force cancelled." : "The scheduled maintenance has been successfully cancelled.";
          await Swal.fire("Maintenance Cancelled", okText, "success");
          this.getMaintenanceList();
        }
      } catch (err) {
        console.error('Error cancelling maintenance:', err);
        Swal.fire("Error", "Failed to cancel maintenance", "error");
      }
    },
    getStatus(data) {
      let status = "";
      // Use UTC parsing to avoid local timezone shifts
      const today = moment().utc();
      const start = data.start_date ? moment.utc(data.start_date) : null;
      const end = data.end_date ? moment.utc(data.end_date) : null;

      // Debugging info (will appear in browser console)
      // eslint-disable-next-line no-console

      if (data.status == "force-cancelled") {
        status = "Force Cancelled";
      } else if (data.status == "cancelled") {
        status = "Cancelled";
      } else if (start && today.isBefore(start)) {
        status = "Scheduled";
      } else if (start && end && (today.isSameOrAfter(start) && today.isSameOrBefore(end))) {
        status = "Ongoing";
      } else if (end && today.isAfter(end)) {
        status = "Ended";
      }
      return status;
    },
    async sortList(action) {
      this.sortBy = action.sortBy;
      this.sortDesc = action.sortDesc;
      
      // Map frontend field keys to backend column names
      const columnMap = {
        network: "name",
        start_date: "start_date",
        end_date: "end_date",
        created_by: "created_by",
        status: "status"
      };
      
      this.orderBy = columnMap[action.sortBy] || `${action.sortBy}`;
      this.sort = action.sortDesc ? "DESC" : "ASC";
      
      await this.getMaintenanceList();
    },
    async onExport() {
      let params = {
        module: "eload_maintenance",
        email: JSON.parse(localStorage.getItem("userData")).email,
        search: this.search,
        sort: this.sort,
        orderBy: this.orderBy,
      };

      this.exportReportExt(params)
        .then(() => Swal.fire("Success!", `Your request for report is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    splitArray(items) {
      if (items) {
        return items.split(",");
      }
    },
  },
  async mounted() {
    this.changeTitle({ title: "E-Load Maintenance" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Peddlr Lite Manager', to: { name: 'Eload Maintenance'} },
        { text: 'E-Load Maintenance', to: { name: 'Eload Maintenance'} }
      ]
    });

    await this.getSKUNetworkList();
    await this.getMaintenanceList();
    // await getModuleAccess("Products", "eLoad B2B", "Request").then((access) => (this.userAccess.access = access));
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <!-- #region Request and Refresh buttons -->
      <div class="d-flex align-items-center py-2">
        <div>
          <h5>{{ eloadMaintenanceTotal }} Record(s)</h5>
        </div>
        <div class="ms-auto">
          <router-link :to="`maintenance/0`">
            <button class="btn btn-primary me-2 mb-2"><i class="uil uil-plus me-1"></i>Maintenance E-Load</button>
          </router-link>
          <button class="btn btn-secondary mb-2" @click="onRefresh()">
            <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
          </button>
        </div>
      </div>
      <!-- #endregion Request and Refresh buttons -->

      <!-- #region Search and Filter -->
      <div class="row p-2">
        <div class="col-md-3 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by Network">
              <b-form-select
                class="form-select rounded shadow-none"
                v-model="search.network"
                :options="networkOptions"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by Status">
              <b-form-select
                class="form-select rounded shadow-none"
                v-model="search.status"
                :options="statusOptions"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-md-3 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by Maintenance Date">
              <flat-pickr
                v-model="search.dateRange"
                :config="rangeOptions"
                placeholder="Select a date"
                class="form-control"
              ></flat-pickr>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 d-flex">
          <div class="me-2">
            <b-button
              variant="primary"
              class="h-fit d-flex align-items-center justify-content-center me-2 w-fit"
              @click="getMaintenanceList"
            >
              <i class="bx bx-search me-1 mt-1"></i>Search
            </b-button>
          </div>
          <div class="">
            <b-button
              variant="primary"
              class="h-fit me-2 d-flex align-items-center justify-content-center w-fit"
              @click="
                isSearching = true;
                onExport();
              "
            >
              <i class="uil uil-export me-1"></i>
              Export
            </b-button>
          </div>
        </div>
      </div>
      <!-- #endregion Search and Filter -->

      <!-- #region Table -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="eloadMaintenanceList"
            :fields="fields"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :no-local-sorting="true"
            class="table-check"
            @sort-changed="sortList"
            tbody-tr-class="align-middle"
          >
            <template #cell(action)="data">
              
              <button type="button" class="btn btn-sm btn-secondary cancelled-button" v-if="getStatus(data.item)=='Scheduled'" @click="cancelSchedule('cancelled', data.item.id)">
                <i class="mdi mdi-calendar-remove"></i>
              </button>
              <button type="button" class="btn btn-sm btn-secondary cancelled-button"  v-if="getStatus(data.item)=='Ongoing'" @click="cancelSchedule('force-cancelled',data.item.id)">
                <i class="mdi mdi-close-circle-outline"></i>
              </button>
              <router-link :to="`maintenance/${data.item.id}`">
                <button type="button" class="btn btn-sm btn-secondary">
                  <i class="mdi mdi-eye-outline"></i>
                </button>
              </router-link>
              
            </template>

            <!-- <template #cell(provider)="data">
              <span v-for="item in setProviders(data.item.provider)" :key="item" class="badge bg-light me-1">{{ item }}</span>
            </template> -->

            <template #cell(network)="data">
              <span v-for="item in splitArray(data.item.network)" :key="item" class="badge bg-light me-1">{{ getNetworkName(item) }}</span>
              <span v-if="!data.item.network" class="badge bg-light me-1">--</span>
            </template>

            <template #cell(start_date)="data">
              <div>{{ data.item.start_date | formatDate }}</div>
            </template>

            <template #cell(end_date)="data">
              <div>{{ data.item.end_date | formatDate }}</div>
            </template>

            <template #cell(status)="data">
              <div
                :class="{
                  'text-scheduled': getStatus(data.item) == 'Scheduled',
                  'text-success': getStatus(data.item) == 'Ongoing',
                  'text-ended': getStatus(data.item) == 'Ended',
                  'text-danger': getStatus(data.item) == 'Cancelled' || getStatus(data.item) == 'Force Cancelled'
                }"
              >
                {{ getStatus(data.item) }}
              </div>
            </template>

            <template #cell(created_by)="data">
              <div>{{ data.item.created_by.slice(19) }}</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row g-0 text-center" v-if="eloadMaintenanceTotal == 0">
        <span>No data to display.</span>
      </div>
      <!-- #endregion Table -->

      <!-- #region Pagination -->
      <div class="row g-0 text-center text-sm-start" v-if="eloadMaintenanceTotal != 0 && eloadMaintenanceTotal > 10">
        <div class="col-sm-12">
          <div class="row">
            <div class="col">
              <div class="form-group row pull-left">
                <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                <div class="col-sm-6">
                  <b-form-group label-for="display-record">
                    <b-form-select
                      class="form-select shadow-none w-fit"
                      id="display-record"
                      v-model="perPage"
                      :options="pageOptions"
                      @change="getMaintenanceList()"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-end" v-if="eloadMaintenanceTotal > perPage">
                <b-pagination
                  class="pagination-rounded"
                  v-model="currentPage"
                  @input="getMaintenanceList()"
                  :total-rows="eloadMaintenanceTotal"
                  :per-page="perPage"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- #endregion Pagination -->
    </div>
  </div>
</template>


<style scoped>
.requesting-color-code {
  color: #dc7512 !important;
}

.img-thumbnail {
  max-height: 50px !important;
}

.disabled {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
}

.text-ended {
  color: #AFAFAF !important;
}
.text-scheduled {
  color: #4D56FF !important;
}
.text-success {
  color: #28a745 !important;
}
.text-danger {
  color: #C12927 !important;
}
.cancelled-button, .cancelled-button {
  margin-right:10px;
  background-color: #C12927;
  border-color: #C12927;
}
.filter-label {
  color: #7E8299;
  font-weight: 600;
  font-size: 0.9rem;
}
</style>

<style>
/* Popup */
.swal-custom-popup {
  border-radius: 10px !important;
  padding: 28px 32px 32px !important;
}

/* Icon circle */
.swal-custom-icon.swal2-icon.swal2-warning {
  border: 3px solid #FEF3E2 !important;
  color: #F5B342 !important;
  width: 65px !important;
  height: 65px !important;
  line-height: 61px !important;
  margin: 0 auto 16px !important;
}

.swal-custom-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  margin-top: 0 !important;
  margin-bottom: 14px !important;
  text-align: center !important;
  color: #1a202c !important;
}

.swal-custom-content {
  text-align: center !important;
  font-size: 14px !important;
  color: #4a5568 !important;
  line-height: 1.5 !important;
}

/* input already styled inline; ensure it doesn't overflow */
.swal2-html-container input.swal2-input {
  box-shadow: none !important;
  margin: 0 !important;
}

/* Buttons */
.swal-custom-confirm {
  background: #7c3aed !important;
  color: #fff !important;
  border-radius: 5px !important;
  padding: 9px 28px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin: 0 8px 0 0 !important;
  border: none !important;
}
.swal-custom-confirm:hover {
  background: #6d28d9 !important;
}
.swal-custom-cancel {
  background: #dc2626 !important;
  color: #fff !important;
  border-radius: 5px !important;
  padding: 9px 22px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin: 0 !important;
  border: none !important;
}
.swal-custom-cancel:hover {
  background: #b91c1c !important;
}

/* counter */
#swal-reason-counter {
  color: #9ca3af;
}

</style>
